export const HOT_DATE_LOCALE = 'en-GB'

export const HOT_DATE_FORMAT = Object.freeze({
  year: 'numeric',
  month: '2-digit',
  day: '2-digit'
})

export function hotNumericFormat(fractionDigits = 2, useGrouping = true) {
  return {
    locale: 'en-US',
    numericFormat: {
      useGrouping,
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits
    }
  }
}
